export const comments_5160003 = {"data":{"data":[],"links":{}}}